/**
 * Version 0.100
 *
 * Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
 * Copyright 2016 - 2026.
 *
 * !Changelog
 *
 * 2025
 * 29-09-2025
 * - [CHANGE] Unbind unnecessary events are gone
 * 2018
 * 	17-10-2018
 * 	- [BORN] This class is born. Hooray!
 *
 * !Usage
 *
 * 	-
 *
 * !Wishlist
 *
 * 	none
 */

var specific_interactions_init = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function () {

		/**
		 * Close the mobilemenu always on route
		 */
		specific_mobilemenu.toggle(1);

		/**
		 * Catch and active URL
		 */
		specific_interactions.catchAndActiveURL();

		/**
		 * Trigger: specific classes
		 */
		// none yet

		/**
		 * Catch the page and scroll to the anchor if given in the URL.
		  */
		var _marge = 0;
		switch (
		url[1]
		) {

			default:
				break;
			case 'openingstijden':
				_marge = $('.block_faq-outside').offset().top - 100;
				break;
			case 'veelgestelde-vragen':
				_marge = $('.block_faq-outside').offset().top - 100;
				break;
			case 'contact':
				_marge = $('.block_faq-outside').offset().top - 100;
				break;
			case 'reserveren':
				_marge = $('.block_reservation').offset().top - 100;
				break;
			case 'reviews':
				_marge = $('.block_reviews').offset().top - 100;
				break;
		}

		$('html, body').animate({
			scrollTop: _marge
		}, 400, 'easeInOutCubic');

		/**
		 * Start luisteren naar postMessage van de embed-reservation iframe
		 */
		specific_interactions_init.listenEmbedReservation();

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	/**
	* Luister naar postMessage van de embed-reservation iframe
	* en stel de hoogte van de container in op basis van de content-hoogte
	*/
	this.listenEmbedReservation = function () {

		/**
	 * Voorkom dat de listener bij iedere route opnieuw wordt toegevoegd.
	 */
		if (specific_interactions_init.embedReservationListenerActive) {
			return;
		}

		specific_interactions_init.embedReservationListenerActive = true;

		window.addEventListener('message', function (e) {

			/**
			 * Alleen berichten van toegestane origins verwerken.
			 */
			var _allowedOrigins = [
				'https://brelamersfoort.nl',
				'https://localhost:3000'
			];

			if (_allowedOrigins.indexOf(e.origin) === -1) {
				return;
			}

			/**
			 * Data kan een object of een JSON-string zijn.
			 */
			var _data = e.data;

			if (typeof _data === 'string') {
				try {
					_data = JSON.parse(_data);
				} catch (err) {
					return;
				}
			}

			if (!_data || typeof _data !== 'object') {
				return;
			}

			/**
			 * Stel de hoogte van de iframe in.
			 */
			if (
				_data.type === 'brelReservationHeight' &&
				_data.height
			) {
				$('.js-embed-reservation iframe').css(
					'height',
					parseInt(_data.height, 10) + 'px'
				);
			}

			/**
			 * Registreer een voltooide reservering in de dataLayer.
			 */
			if (_data.event === 'reservation_complete') {

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: 'reservation_complete'
				});

			}

		});

	};

}).apply(specific_interactions_init);